// extracted by mini-css-extract-plugin
export var active = "_lp-2";
export var recordingDot = "_lp-1";
export var recordingIndicator = "_lp-0";